module.exports = __webpack_public_path__ + "img/30m10.421d80a2.jpg";